/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Set_Team_AInputs */

const en_us2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put in Team A`)
};

const pt_br2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar no Time A`)
};

const es_419_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasar al Equipo A`)
};

const pt_pt2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pôr na Equipa A`)
};

const fr_fr2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en équipe A`)
};

const de_de2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Team A`)
};

const it_it2_clubs_set_team_a = /** @type {(inputs: Clubs_Set_Team_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti nella Squadra A`)
};

/**
* | output |
* | --- |
* | "Put in Team A" |
*
* @param {Clubs_Set_Team_AInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_set_team_a = /** @type {((inputs?: Clubs_Set_Team_AInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Set_Team_AInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_set_team_a(inputs)
	if (locale === "es-419") return es_419_clubs_set_team_a(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_set_team_a(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_set_team_a(inputs)
	if (locale === "de-DE") return de_de2_clubs_set_team_a(inputs)
	if (locale === "it-IT") return it_it2_clubs_set_team_a(inputs)
	return en_us2_clubs_set_team_a(inputs)
});
export { clubs_set_team_a as "clubs.set_team_a" }